import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import ShippingManifest from "./shipping-manifest.model";

export default class ShippingManifestFactory
  implements ObjectBuilderInterface<ShippingManifest> {
  public buildFromJSON(data: { [key: string]: unknown }): ShippingManifest {
    const value = new ShippingManifest(
      data.id as string,
      data.factoryId as string,
      data.trackingNumber as string,
      (data.bulkShipmentIds as string[] | undefined) || [],
      data.carrier as string,
      data.notes as string | undefined,
      data.incrementalId as number | undefined
    );

    value.isNew = false;

    return value;
  }
}
